import { render, staticRenderFns } from "./TooltipVT.vue?vue&type=template&id=6a755220&scoped=true"
import script from "./TooltipVT.vue?vue&type=script&lang=js"
export * from "./TooltipVT.vue?vue&type=script&lang=js"
import style0 from "./TooltipVT.vue?vue&type=style&index=0&id=6a755220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a755220",
  null
  
)

export default component.exports